import { render, staticRenderFns } from "./SidebarDropdown.vue?vue&type=template&id=6d876340&scoped=true"
import script from "./SidebarDropdown.vue?vue&type=script&lang=js"
export * from "./SidebarDropdown.vue?vue&type=script&lang=js"
import style0 from "./SidebarDropdown.vue?vue&type=style&index=0&id=6d876340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d876340",
  null
  
)

export default component.exports